export default{
    //计算时区时间
	datetime2zone_x(_date_time, _zone) {
				// console.log(_date_time)
				//定义utc时区字段
				const UTC_ZONE = {
				    "UTC-0000": -0 * 3600 * 1000,
				    "UTC-0100": -1 * 3600 * 1000,
				    "UTC-0200": -2 * 3600 * 1000,
				    "UTC-0300": -3 * 3600 * 1000,
				    "UTC-0400": -4 * 3600 * 1000,
				    "UTC-0500": -5 * 3600 * 1000,
				    "UTC-0600": -6 * 3600 * 1000,
				    "UTC-0700": -7 * 3600 * 1000,
				    "UTC-0800": -8 * 3600 * 1000,
				    "UTC-0900": -9 * 3600 * 1000,
				    "UTC-1000": -10 * 3600 * 1000,
				    "UTC-1100": -11 * 3600 * 1000,
				    "UTC-1200": -12 * 3600 * 1000,
				    "UTC+0000": 0 * 3600 * 1000,
				    "UTC+0100": 1 * 3600 * 1000,
				    "UTC+0200": 2 * 3600 * 1000,
				    "UTC+0300": 3 * 3600 * 1000,
				    "UTC+0400": 4 * 3600 * 1000,
				    "UTC+0500": 5 * 3600 * 1000,
				    "UTC+0600": 6 * 3600 * 1000,
				    "UTC+0700": 7 * 3600 * 1000,
				    "UTC+0800": 8 * 3600 * 1000,
				    "UTC+0900": 9 * 3600 * 1000,
				    "UTC+1000": 10 * 3600 * 1000,
				    "UTC+1100": 11 * 3600 * 1000,
				    "UTC+1200": 12 * 3600 * 1000
				};
				//如果参数返回false返回的显示字段
			    if (!_date_time){
					return "N/A";
					}
				//时区毫秒数
			    var office = UTC_ZONE[_zone];
			    var temp_date = null;
			    if (typeof _date_time == "string") {
					//如果参数是最初时间
			        if (_date_time == "1970-01-01 00:00:00"){
						 return "N/A";
					}
			        //如果参数是0000 
					if (_date_time == "0000-00-00 00:00:00"){
						 return "N/A";
					}
			        //如果参数是null  
			        if (_date_time == "null"){
						return "N/A";
					}
			        //如果字符串没有utc字符
					// console.log(_date_time)
					// console.log(_date_time.indexOf("UTC"))
			        if (_date_time.indexOf("UTC") < 0){
						_date_time += " UTC+0000";
						//将’-‘替换成’/‘兼容ie浏览器
						_date_time = _date_time.replace(/\-/g,'/')
						//将字符串转换成时间对象
						temp_date = new Date(_date_time);
						// console.log(temp_date)
					}
					 
				}else{//如果不是字符串
						temp_date = _date_time;
					}
				//返回正确格式的时间字符
			    function to_2_str(_value) {
			        if (_value < 10)
			            return "0" + _value;
			        else
			            return _value;
			    };
				//获取时区的毫秒数
				var temp = new Date(temp_date.getTime() + office);
				// console.log(temp_date)
				//获取带时区的时间
			    var date_str = temp.getUTCFullYear()
			        + "-"
			        + to_2_str(temp.getUTCMonth() + 1)
			        + "-"
			        + to_2_str(temp.getUTCDate())
			        + " "
			        + to_2_str(temp.getUTCHours())
			        + ":"
			        + to_2_str(temp.getUTCMinutes())
			        + ":"
			        + to_2_str(temp.getUTCSeconds())
					+ " " + _zone;
			    return date_str;
	},
	//每个列的加载宽度
	calculated_width(fields){
		this.th_width=[];
		// console.log(fields)
		fields.forEach((item)=>{
			if(item.ShowWidth){
				this.th_width.push(item.ShowWidth)
			}else{
				// console.log(item)
				this.th_width.push(150)
				// console.log(this.th_width)
			}
		})
		return this.th_width
	},
	//捕获异步错误
	async_error(promise){
		return promise.then(res => res).catch(error => this.error_message(error));
	},
	//动态接口参数
	dynamic_interface_parameters(search,nd,rows,page,sidx,sord,filters){
		return {_search:search, nd:nd, rows:rows, page:page, sidx:sidx, sord:sord, filters:filters, searchField:'', searchString:'', searchOper:'',}
	},
}